import 'bootstrap/dist/css/bootstrap.min.css';
import ITCLogo from '../../assets/Images/CommonImages/ITClogo.png';
import DriverAlerts from '../Dispatch/Alerts/DriverAlerts.js';
import APICom from "../../utils/helpers/APICom.js";
import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from "react-redux";
import { Button , Modal } from 'react-bootstrap';

const HeaderComponent = ({affSelected, loginData}) => {
    // const { loginData } = useSelector((store) => store.login);
    const [showDriverAlerts, setShowDriverAlerts] = useState(false);
    const [showAlertsTitleHTML, setShowAlertsTitleHTML] = useState(null);
    const [AffChange, setAffChange] = useState(0);
    const AffiliateIDForAlertsRef = useRef(null);
    const AlertsRef = useRef(null);
    const xCancelSourceForGrid = useRef(null);
    const UserLoginData = useRef([]);

    const handleShowAlertCounts = async(aff)=>{
        try{
            let data = {
                "vAffiliates": UserLoginData.current? String(UserLoginData.current.UserAffiliateList):String(loginData.UserAffiliateList),
                "iMode": "1",
                "selectedAffiliate": (aff?
                    aff:(UserLoginData.current? parseInt(UserLoginData.current.UserAffiliateList?.split(",")[0]):parseInt(loginData.UserAffiliateList?.split(",")[0])))
            };
            xCancelSourceForGrid.current = APICom.GenerateSource();
            // console.log("inside header data", aff);
            let response = await APICom.fetchData("main","TripActions/GetAlarms", "post", {}, data, xCancelSourceForGrid.current);
            if(response.data && response.data.AllAlerts.length > 0)
            {
                let countDataArr = response.data.AllAlerts[0];
                let driverPenaltyCountForAff = 0;
                let emergencyCount = 0;
                let noshowCount = 0;
                let othersCount = 0;
                let lateCount = 0;
                let deviceCount = 0;
                let alarmsArr = response.data.Alarms;
                let alertsArr = response.data.AlertDetails;
                if(countDataArr.TotalDriverPenaltyCount > 0)
                {
                    let driverPenaltyArr = response.data.DriverPenalty;
                    for(let l = 0; l < driverPenaltyArr.length; l++)
                    {
                        if(parseInt(driverPenaltyArr[l].iAlertAffiliateID) === aff)
                        {
                            driverPenaltyCountForAff+=1;
                        }
                    }
                }
                if(response.data.DeviceDetails && response.data.DeviceDetails.length > 0)
                {
                    let deviceLockArr = response.data.DeviceDetails;
                    for(let j = 0; j < deviceLockArr.length; j++)
                    {
                        if(parseInt(deviceLockArr[j].iAffiliateID) === aff)
                        {
                            deviceCount+=1;
                        }
                    }
                }
                if(response.data.LateDetails && response.data.LateDetails.length > 0)
                {
                    let LateTripsArr = response.data.LateDetails;
                    for(let j = 0; j < LateTripsArr.length; j++)
                    {
                        if(parseInt(LateTripsArr[j].RequestAffiliateID) === aff)
                        {
                            lateCount+=1;
                        }
                    }
                }
                if(alarmsArr && alarmsArr.length > 0)
                {
                    for(let k = 0; k < alarmsArr.length; k++)
                    {
                        if(parseInt(alarmsArr[k].iAlertAffiliateID) === aff)
                        {
                            if(alarmsArr[k]["Alert Type"] === "")
                            {
                                othersCount+=1;
                            }
                            else if(alarmsArr[k]["Alert Type"].toLowerCase().includes("emergency"))
                            {
                                emergencyCount+=1;
                            }
                            else if(alarmsArr[k]["Alert Type"].toLowerCase().includes("noshow"))
                            {
                                noshowCount+=1;
                            }
                            // else if(alarmsArr[k]["Alert Type"].toLowerCase().includes("late"))
                            // {
                            //     lateCount+=1;
                            // }
                        }
                        
                    }
                }
                else if(alertsArr && alertsArr.length > 0)
                {
                    for(let k = 0; k < alertsArr.length; k++)
                    {
                        if(parseInt(alertsArr[k].iAlertAffiliateID) === aff)
                        {
                            if(alertsArr[k]["Alert Type"] === "")
                            {
                                othersCount+=1;
                            }
                            else if(alertsArr[k]["Alert Type"].toLowerCase().includes("emergency"))
                            {
                                emergencyCount+=1;
                            }
                            else if(alertsArr[k]["Alert Type"].toLowerCase().includes("noshow"))
                            {
                                noshowCount+=1;
                            }
                            // else if(alertsArr[k]["Alert Type"].toLowerCase().includes("late"))
                            // {
                            //     lateCount+=1;
                            // }
                        }
                    }
                }
                let alertsTitleHTML = function(index){
                    return(
                        <span key={index} style={{fontSize:"small"}}> <span className='text-dark bg-white small px-2 py-1' style={{borderRadius:"10px"}}>{"ALERTS"}</span>
                            <span className='text-white mx-1 px-1 fw-normal'>
                                <span title={"Emergency Alert Count"} style={{fontSize:"small"}}>
                                    {"| EM"} 
                                    {emergencyCount > 0 ? 
                                        <span className='fw-bold text-danger mx-1'>{emergencyCount}</span>
                                        :<span className='fw-bold text-white mx-1'>{0}</span>
                                    }
                                </span>
                                <span title={"No-Show Alert Count"} style={{fontSize:"small"}}>
                                    {"| NS"} 
                                    {noshowCount > 0 ? 
                                        <span className='fw-bold text-danger mx-1'>{noshowCount}</span>
                                        :<span className='fw-bold text-white mx-1'>{0}</span>
                                    }
                                </span>
                                <span title={"Late Pickup Alert Count"} style={{fontSize:"small"}}>
                                    {"| LT"} 
                                    {lateCount > 0 ? 
                                        <span className='fw-bold text-danger mx-1'>{lateCount}</span>
                                        :<span className='fw-bold text-white mx-1'>{0}</span>
                                    }
                                </span>
                                <span title={"Device Lock Alert Count"} style={{fontSize:"small"}}>
                                    {"| DL"} 
                                    {deviceCount > 0 ? 
                                        <span className='fw-bold text-danger mx-1'>{deviceCount}</span>
                                        :<span className='fw-bold text-white mx-1'>{0}</span>
                                    }
                                </span>
                                <span title={"Driver Penalty Count"} style={{fontSize:"small"}}>
                                    {"| DP"} 
                                    {driverPenaltyCountForAff > 0 ? 
                                        <span className='fw-bold text-danger mx-1'>{driverPenaltyCountForAff}</span>
                                        :<span className='fw-bold text-white mx-1'>{0}</span>
                                    }
                                </span>
                                <span title={"Other Alerts Count"} style={{fontSize:"small"}}>
                                    {"| OT"} 
                                    {othersCount > 0 ? 
                                        <span className='fw-bold text-danger mx-1'>{othersCount}</span>
                                        :<span className='fw-bold text-white mx-1'>{0}</span>
                                    }
                                </span>
                            </span>
                        </span>
                    );
                };
                setShowAlertsTitleHTML(alertsTitleHTML);
            }
        }
        catch(err){console.log(err);}
    };
    const handleOpenAlerts = ()=>{
        if(Object.keys(UserLoginData.current)?.length > 0)
        {
            setShowDriverAlerts(true);
            
        }
        else
        {
            setShowDriverAlerts(false);
        }
    };

    useEffect(() => {
        try{
            if(Object.keys(loginData)?.length === 0 || window.location.href.toLowerCase().includes("callagent"))
            {
                setShowAlertsTitleHTML(<span>{"ALERTS"}</span>);
                AlertsRef.current.className = "d-none";
            }
            else
            {
                UserLoginData.current = loginData;
                handleShowAlertCounts(AffiliateIDForAlertsRef.current);
                AlertsRef.current.className = "m-0 mx-2 text-white fw-bold bg-dark float-end px-2 py-1 shadow user-select-none d-block";
            }
        }
        catch(err){console.log(err);}

        AffiliateIDForAlertsRef.current =  parseInt(affSelected);
      }, [affSelected]);

    useEffect(() => {
        const interval = setInterval(() => {
          if (Object.keys(UserLoginData.current)?.length > 0) {
            handleShowAlertCounts(AffiliateIDForAlertsRef.current);
          }
        }, 30000);
      
        // Clear interval on component unmount
        return () => clearInterval(interval);
      }, []);
      


    useEffect(() => {
        try{
            if(Object.keys(loginData)?.length === 0 || window.location.href.toLowerCase().includes("callagent"))
            {
                setShowAlertsTitleHTML(<span>{"ALERTS"}</span>);
                AlertsRef.current.className = "d-none";
            }
            else
            {
                UserLoginData.current = loginData;
                handleShowAlertCounts(AffiliateIDForAlertsRef.current);
                AlertsRef.current.className = "m-0 mx-2 text-white fw-bold bg-dark float-end px-2 py-1 shadow user-select-none d-block";
            }
        }
        catch(err){console.log(err);}
    }, []);

    return (
        <>
            <nav className="navbar fixed-top navbar-expand-lg page-header d-block" style={{height:'50px'}}>
                <img src={ITCLogo} className='ITCLogo page-header-logo user-select-none' alt="ITCurves" />
                <p className='m-0 mx-2 text-white fw-bold bg-dark float-end px-2 py-1 shadow user-select-none' 
                    ref={AlertsRef} onClick={handleOpenAlerts} title={"Display Driver Alerts"} style={{cursor:"pointer", borderRadius:"10px"}}>
                        {showAlertsTitleHTML}
                </p>
                <DriverAlerts selectedAff={AffiliateIDForAlertsRef.current} showDriverAlerts={showDriverAlerts} setShowDriverAlerts={setShowDriverAlerts}/>
            </nav>
        </>
    );
};

export default HeaderComponent;